import React from "react";
import { BadgeCheck, ShieldCheck } from "lucide-react";

const badges = [
  {
    acronym: "HCPC",
    full: "Health & Care Professions Council",
    line: "Registered",
    Icon: ShieldCheck,
    href: "https://www.hcpc-uk.org",
  },
  {
    acronym: "CSP",
    full: "Chartered Society of Physiotherapy",
    line: "Member",
    Icon: BadgeCheck,
    href: "https://www.csp.org.uk",
  },
];

export default function Accreditations() {
  return (
    <section
      className="py-12 md:py-16 px-6 md:px-12 bg-brand-cream border-y border-brand-clay"
      aria-label="Professional accreditations"
      data-testid="accreditations-section"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12">
        <p className="text-sm font-semibold tracking-[0.2em] uppercase text-brand-terracotta text-center md:text-left" data-testid="accreditations-eyebrow">
          Regulated · Chartered · Trusted
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6 flex-1 justify-end">
          {badges.map((b) => {
            const Icon = b.Icon;
            return (
              <a
                key={b.acronym}
                href={b.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-4 bg-white border border-brand-clay hover:border-brand-blue/40 rounded-2xl pl-4 pr-6 py-3 transition-all duration-300 hover:shadow-md min-w-[260px]"
                data-testid={`accreditation-${b.acronym.toLowerCase()}`}
              >
                <span className="shrink-0 w-12 h-12 rounded-xl bg-brand-blue text-white flex items-center justify-center">
                  <Icon size={24} strokeWidth={1.8} />
                </span>
                <span className="flex flex-col leading-tight">
                  <span className="font-display text-2xl text-brand-blue">{b.acronym}</span>
                  <span className="text-xs uppercase tracking-wider text-brand-terracotta font-semibold">{b.line}</span>
                  <span className="text-xs text-slate-500 mt-0.5">{b.full}</span>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
